import type { ECountryCode } from "@/domains/country/country.types";

export enum ESiteAddressProvider {
  GOOGLE = "GOOGLE",
  GOUVFR = "GOUVFR",
  UNKNOWN = "UNKNOWN",
}

export type TSiteAddress = ISitePartialNonGeocodedAddress | ISiteNearbyGeocodedAddress | ISiteExactGeocodedAddress;

interface ISiteAddressComplement {
  complement: string | null;
  digicode: string | null;
  building: string | null;
  level: number | null;
  stairway: string | null;
}

export interface ISitePartialNonGeocodedAddress extends ISiteAddressComplement {
  type: "NON_GEOCODED";
  addressLine1: string | null;
  zipCode: string | null;
  city: string | null;
  country: ECountryCode;
}

export interface ISiteNearbyGeocodedAddress extends ISiteAddressComplement {
  type: "NEARBY";
  addressLine1: string;
  zipCode: string;
  city: string;
  country: ECountryCode;
  nearbyFields: {
    externalId: string | null;
    streetNumber: string | null;
    street: string | null;
    zipCode: string;
    city: string;
    score: number | null;
    latitude: number;
    longitude: number;
    cityCode: string | null;
    administrativeDivisions: Array<string>;
    provider: ESiteAddressProvider;
  };
}

export interface ISiteExactGeocodedAddress extends ISiteAddressComplement {
  type: "GEOCODED";
  street: string;
  streetNumber: string | null;
  addressLine1: string;
  zipCode: string;
  city: string;
  country: ECountryCode;
  geocodedFields: {
    externalId: string | null;
    score: number | null;
    administrativeDivisions: Array<string>;
    cityCode: string | null;
    latitude: number;
    longitude: number;
    provider: ESiteAddressProvider;
  };
}
